<div>
    <mat-form-field class="w-full">
            <mat-icon>search</mat-icon>
            <input
                matInput
                placeholder="Buscar gestión..."
                #fruitInput
                id="gestionActual"
                name="gestionActual"
                [(ngModel)]="gestionActual"
                [matAutocomplete]="auto"
                (input)="onInputChange()"   
                />
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event);">
                <mat-option *ngFor="let gestion of filteredGestiones" [value]="gestion.nombre">
                {{ gestion.nombre }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
       
        <table mat-table [dataSource]="gestionesSeleccionadas"  class="w-full">
            <!-- Nombre Column -->
            <ng-container matColumnDef="nombre">
                <td mat-cell *matCellDef="let gestion"> {{gestion.nombre}} </td>
            </ng-container>

            <!-- acciones Column -->
            <ng-container matColumnDef="acciones">
                <td mat-cell *matCellDef="let gestion">
                    <button mat-icon-button (click)="remove(gestion)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-row *matRowDef="let row; columns: ['nombre', 'acciones']" class="border-b"></tr>
        </table>
</div>